import { render, staticRenderFns } from "./TagPantalla.vue?vue&type=template&id=1ad93282&scoped=true&"
import script from "./TagPantalla.vue?vue&type=script&lang=ts&"
export * from "./TagPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./TagPantalla.vue?vue&type=style&index=0&id=1ad93282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad93282",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1ad93282', component.options)
    } else {
      api.reload('1ad93282', component.options)
    }
    module.hot.accept("./TagPantalla.vue?vue&type=template&id=1ad93282&scoped=true&", function () {
      api.rerender('1ad93282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TagBluetooth/TagPantalla.vue"
export default component.exports